module.exports = __webpack_public_path__ + "static/massage_maroon-7f45be05533dc255d449507152e0e6fe.png";